import { getMajorAsset } from '@/utils/dataFormatter'
import './Logo.css'

import type { MatchData } from '@/types'
import type { FC } from 'react'

export interface LogoProps {
  matchConfig: MatchData
  slotId: 1 | 2
  teamName: string
  maxW?: string
  maxH?: string
}

const Logo: FC<LogoProps> = ({ matchConfig, slotId, teamName, maxW = '100%', maxH = '20rem' }) => {
  const logoUrl = getMajorAsset(matchConfig, slotId)

  return (
    <div className={`logo-container logo-container--${slotId === 1 ? 'left' : 'right'}`}>
      {logoUrl && (
        <img src={logoUrl} alt={teamName} className="logo-image" style={{ maxWidth: maxW, maxHeight: maxH }} />
      )}
    </div>
  )
}

export default Logo
